import { useState } from 'react';

/** A short text in a bottom sheet: the reason for a thumbs down, or app feedback. */
export function TextSheet({ title, placeholder, onSend }: { title: string; placeholder: string; onSend: (text: string) => Promise<void> }) {
  const [text, setText] = useState('');
  const [busy, setBusy] = useState(false);
  return (
    <div className="chats-pad">
      <h2 className="chats-sheet-title">{title}</h2>
      <textarea className="chats-input chats-input--stack" rows={3} value={text} onChange={(e) => setText(e.target.value)} placeholder={placeholder} aria-label={title} autoFocus />
      <button type="button" className="chats-btn" disabled={busy || !text.trim()} onClick={() => { setBusy(true); void onSend(text.trim()).finally(() => setBusy(false)); }}>Save</button>
    </div>
  );
}
